import React, { Component } from "react"
import { utils } from "../constants"


/* Component Payout */
class GamePayout extends Component {

    render = () => {

        /* Fields */
        const { min, max, currency } = this.props

        /* Bonus */
        const bonusMax = parseFloat(max) / 10
        const perfectPairMax = parseFloat(max) / 100 * 3

        return (
            <div className="game-payout">
                <div className="game-payout--container">

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">PLAYER</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(max, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">1:1</div>
                    </div>

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">BANKER</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(max, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">0.95:1</div>
                    </div>

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">TIE</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(max, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">8:1</div>
                    </div>

                    <div className="game-payout--space" />

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">PLAYER PAIR</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(bonusMax, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">11:1</div>
                    </div>

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">BANKER PAIR</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(bonusMax, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">11:1</div>
                    </div>

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">EITHER PAIR</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(bonusMax, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">5:1</div>
                    </div>

                    <div className="game-payout--box">
                        <div className="game-payout--name">
                            <div className="game-payout--title">PERFECT PAIR</div>
                            <div className="game-payout--text">{utils.convertor(min, currency)} - {utils.convertor(perfectPairMax, currency)}</div>
                        </div>
                        <div className="game-payout--multiplier">25:1</div>
                    </div>

                </div>
            </div>
        )
    }
}

export default GamePayout